module.exports = __webpack_public_path__ + "img/download_ios.43a0180c.png";